import Layer from "../utils/Layer";
import ViewManager from "../utils/ViewManager";
import { DefaultLayers } from "../utils/Layers";
import PointerEvents from "../../src/const/PointerEvents";
import SceneView from "../views/SceneView";
import AbstractPopup from "./popups/AbstractPopup";
import GameModel from "../model/GameModel";

export default abstract class BaseSettings extends AbstractPopup {
    public backgroundLayer: Layer = ViewManager.getLayer(DefaultLayers.MenusBackground);
    public contentLayer: Layer = ViewManager.getLayer(DefaultLayers.MenusContent);
    public interfaceLayer: Layer = ViewManager.getLayer(DefaultLayers.MenuUI);
    public defaultPage: string;
    protected navigationActions: Map<string, (e?: Event) => void> = new Map();
    protected interfaceScene: SceneView;
    protected view: BaseSettings;

    public show(page?: string) {
        super.show();
        this.setupNavigationInterface();
    }

    protected setupNavigationInterface() {
        this.backgroundLayer.setScene('open');
        this.backgroundLayer.interactive = true;
        this.interfaceLayer.setScene('open');

        this.interfaceScene = this.interfaceLayer.getCurrentScene();
        this.interfaceScene.buttons.forEach((button, name) => {
            button.on(PointerEvents.DOWN, this.navigationListener(name), this);
        });

        let versionLabel = this.interfaceScene.sceneTextFields?.get("version");
        if (versionLabel) {
            versionLabel.text = GameModel.gameVersion;

            if (GameModel?.gameConfig?.versionDate) {
                versionLabel.text += "\n" + GameModel.gameConfig.versionDate;
            }
        }
    }

    protected navigationListener(name) {
        return this.navigationActions.get(name) || (() => {
        });
    }

    protected removeListeners() {
        let scene = this.interfaceLayer?.getCurrentScene();
        scene?.buttons.forEach((button, name) => {
            button.off(PointerEvents.DOWN, this.navigationListener(name), this);
        });
    }

    public hide() {
        super.hide();
        this.removeListeners();
        this.backgroundLayer.clear();
        this.interfaceLayer.clear();
        this.contentLayer.clear();
        this.interfaceScene = null;
    }

    public toggle(page?: string) {
        if (this.hidden) {
            this.show(page);
        } else {
            this.hide();
        }
    }
}
